import React, { Suspense } from "react";
import { AppRouter } from "./routers/AppRouter";
import '@coreui/coreui/dist/css/coreui.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import "primereact/resources/themes/lara-light-cyan/theme.css";
import './scss/style.scss'
import { Loading } from "./views/Loading";

function App() {
  return (
    <Suspense fallback={<Loading />}>
      <AppRouter />
    </Suspense>
  );
}

export default App;
